import { Grid } from "@mui/material";

import { Paper } from "../../../components";
import { ActiveTextEighteen, colors } from "../../css components/Style";

export default function AdminBrandStatus({ formData }) {
  return (
    <Paper>
      {formData.status === "REJECTED" && (
        <Grid item xs={12}>
          <ActiveTextEighteen color={colors.error}>
            The brand has been rejected.
          </ActiveTextEighteen>
        </Grid>
      )}

      {!formData.status && (
        <Grid item xs={12}>
          <ActiveTextEighteen color={colors.warning}>
            The brand is in pending state.
          </ActiveTextEighteen>
        </Grid>
      )}

      {formData.status === "APPROVE" && (
        <Grid item xs={12}>
          <ActiveTextEighteen color={colors.green}>
            The brand has been accepted.
          </ActiveTextEighteen>
        </Grid>
      )}
    </Paper>
  );
}
